import {useMemo} from 'react';
import {useSelector} from 'react-redux';
import {getTipsGuideByType} from '@/services/content/tipsContent';
import eventMessagesService from '@/services/events/eventMessagesService';
import {selectDeviceType, selectTipsType} from '@/state/selectors/app';
import arrayUtils from '@/utils/arrayUtils';

const useTipsGuideContent = () => {
    const deviceType = useSelector(selectDeviceType);
    const tipsType = useSelector(selectTipsType);

    const {title, description, cards, backgroundImage} = useMemo(() => {
        const tipsGuide = getTipsGuideByType(tipsType);
        const itemForDevice = tipsGuide.find((item: any) => {
            return item.deviceType?.deviceType === deviceType;
        });

        if (!itemForDevice) {
            eventMessagesService.sendModuleInitializationError(
                `Tips guide content not found for deviceType: ${deviceType}`
            );
        }

        const {title = '', description = '', items = [], backgroundImage} = itemForDevice || {};
        const cards = arrayUtils.sortArrayWithOrderField(items);

        return {title, description, cards, backgroundImage};
    }, [tipsType, deviceType]);

    return {title, description, cards, backgroundImage};
};

export default useTipsGuideContent;
